import { Config } from '@backstage/config';
import {
  RadarRing,
  RadarQuadrant,
  RadarEntry,
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';

export class MyTechRadarClient implements TechRadarApi {
  config: Config;

  constructor(configApiRef: Config) {
    this.config = configApiRef;
  }

  async load(): Promise<TechRadarLoaderResponse> {
    // if needed id prop can be used to fetch the correct data

    const rings = new Array<RadarRing>();
    rings.push({ id: 'adopt', name: 'ADOPT', color: '#93c47d' });
    rings.push({ id: 'trial', name: 'TRIAL', color: '#93d2c2' });
    rings.push({ id: 'assess', name: 'ASSESS', color: '#fbdb84' });
    rings.push({ id: 'hold', name: 'HOLD', color: '#efafa9' });

    const quadrants = new Array<RadarQuadrant>();
    quadrants.push({ id: 'infrastructure', name: 'Infrastructure' });
    quadrants.push({ id: 'frameworks', name: 'Frameworks' });
    quadrants.push({ id: 'languages', name: 'Languages' });
    quadrants.push({ id: 'process', name: 'Process' });

    const data = await fetch(
      `${this.config.getString('app.baseUrl')}/techradardata.json`,
    ).then(res => res.json());

    console.log(data);

    const entries = data.entries.map((entry: RadarEntry) => ({
      ...entry,
      timeline: entry.timeline.map((timeline: any) => ({
        ...timeline,
        date: new Date(timeline.date),
      })),
    }));

    const mock: TechRadarLoaderResponse = {
      entries,
      quadrants,
      rings,
    };

    return mock;

    // For example, this converts the timeline dates into date objects
    // return {
    //   ...data,
    //   entries: data.entries.map(entry => ({
    //     ...entry,
    //     timeline: entry.timeline.map(timeline => ({
    //       ...timeline,
    //       date: new Date(timeline.date),
    //     })),
    //   })),
    // };
  }
}
